// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1795":"css/app.6908","3362":"css/admin-app.6908"}[chunkId] + ".css";
};